import { PreviewCart } from "../cart/preview-cart";
import { GeneralOverlay } from "../general/general-overlay";
export class Header extends HTMLElement {
    constructor() {
        super();

        this.bindEvents();
    }

    bindEvents() {
        const linkEle = this.querySelectorAll('.header-content__left-link');
        linkEle.forEach((ele) => {
            ele.addEventListener("mouseenter", this.linkMouseOverEventHandler.bind(this))
            ele.addEventListener("mouseleave", this.linkMouseUpEventHandler.bind(this))
        })

        const mobileItemTitleEle = this.querySelectorAll('.mega-menu-mobile .mega-menu__col-title');
        mobileItemTitleEle.forEach((ele) => {
            ele.addEventListener("click", this.toggleAccordion.bind(this))
        })

        const mobileBurgerEle = this.querySelector('.icon-menu-mobile .burger');
        mobileBurgerEle?.addEventListener("click", this.openMobileMegaMenu.bind(this))

        const mobileClsoeEle = this.querySelector('.icon-menu-mobile .close');
        mobileClsoeEle?.addEventListener("click", this.closeMobileMegaMenu.bind(this))

        const previewCartIcon = this.querySelector('.icon-pram');
        previewCartIcon?.addEventListener("click", this.openPreviewCart.bind(this));

        const searchIcon = this.querySelector(".icon-search-mobile");
        searchIcon?.addEventListener("click", this.toggleMobileSearchBar.bind(this));
    }

    toggleMobileSearchBar(event: Event) {
        this.classList.toggle("mobile-search-open");

        if(this.classList.contains("mobile-mega-menu-open")) {
            const mobileMegaIcon = this.querySelector(".icon-menu-mobile .close") as HTMLElement; 
            mobileMegaIcon?.click();
        }
    }

    linkMouseOverEventHandler(event: Event) {
        const targetEle = event.currentTarget as HTMLElement;
        const hasMegaMenu = targetEle.classList.contains('no-mega');
        if(!hasMegaMenu) {
            this.classList.add('mega-menu-open');
            this.previousElementSibling?.classList.remove('hidden');
        }
    }

    linkMouseUpEventHandler(event: Event) {
        this.classList.remove('mega-menu-open');
        this.previousElementSibling?.classList.add('hidden');

    }

    toggleAccordion(event: Event) {
        const target = <HTMLElement>event.currentTarget;
        const siblingEle = <HTMLElement>target.nextElementSibling;
        siblingEle?.classList.toggle("active");
        target?.classList.toggle("accordion-open");
    }

    openMobileMegaMenu() {
        const burgerIconEle = this.querySelector('.icon-menu-mobile .burger');
        const closeIconEle = this.querySelector(".icon-menu-mobile .close");
        const mobileMenuEle = this.querySelector('.header-content__mobile-wrapper');

        if(this.classList.contains("mobile-search-open")) {
            const searchIcon = this.querySelector(".icon-search-mobile") as HTMLElement; 
            searchIcon?.click();
        }

        burgerIconEle?.classList.add('hide');
        closeIconEle?.classList.remove('hide');
        mobileMenuEle?.classList.add("open");
        this.classList.add("mobile-mega-menu-open");

        const generalOverlay = new GeneralOverlay();
        generalOverlay.applyOverlay(document.querySelector(".section-header"));
    }

    closeMobileMegaMenu() {
        const burgerIconEle = this.querySelector('.icon-menu-mobile .burger');
        const closeIconEle = this.querySelector(".icon-menu-mobile .close");
        const mobileMenuEle = this.querySelector('.header-content__mobile-wrapper');

        burgerIconEle?.classList.remove('hide');
        closeIconEle?.classList.add('hide');
        mobileMenuEle?.classList.remove("open");
        this.classList.remove("mobile-mega-menu-open");

        const generalOverlay = new GeneralOverlay();
        generalOverlay.removeOverlay(document.querySelector(".section-header"));
    }

    openPreviewCart(event: Event) {
        const previewCart = new PreviewCart();
        previewCart.openPreviewCart();
    }
}

customElements.define("header-wrapper", Header);